import { cn } from "./cn";

/** "Asha Rao" → "AR"; no name → the email's first letter; nothing → "?". */
export function initials(name: string | null | undefined, email: string | null | undefined): string {
  const source = name?.trim() || email?.split("@")[0] || "?";
  return source
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? "")
    .join("");
}

/** A person's initials in a circle (no photos: the API keeps none). */
export function Avatar({
  name,
  email,
  size = "md",
  className,
}: {
  name: string | null | undefined;
  email: string | null | undefined;
  size?: "sm" | "md" | "lg";
  className?: string;
}) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        "flex shrink-0 items-center justify-center rounded-full bg-avatar font-bold text-on-avatar",
        size === "sm" && "size-8 text-xs",
        size === "md" && "size-9 text-sm",
        size === "lg" && "size-14 text-lg",
        className,
      )}
    >
      {initials(name, email)}
    </span>
  );
}
